<script>
	export default {
		name: 'SnackbarExecuter',
		methods: {
			showSnackbar(information) {
				const self_ = this;

				let info_ = {}
				// text
				if(self_.isFalse(information.text)) { return }
				else { info_.text = information.text }
				// icon
				if(self_.isFalse(information.icon)) { info_.icon = null }
				else { info_.icon = information.icon }
				// link
				if(self_.isEmpty(information.link)) { info_.link = null }
				else { info_.link = information.link }
				// timeout
				if(self_.isFalse(information.timeout)) { info_.timeout = 5000 }
				else { info_.timeout = information.timeout }
				// set
				self_.setComponentState('informationSnackbar', info_)
				// show
				self_.setComponentState('showInformationSnackbar', true)
			},
			hideSnackbar() {
				const self_ = this;

				self_.setComponentState('informationSnackbar', {})
				self_.setComponentState('showInformationSnackbar', false)
			}
		}
	}
</script>